// Components==============
import React, { useContext } from 'react';
import { FlashExerciseContext } from '../../FlashExercise';
import './FlashBox.module.scss';
// =========================

export default function FlashBox({ word }: { word: Words }) {
    const { answer, displayCard } = useContext(FlashExerciseContext);

    const isActive = answer === word;

    return (
        <div
            styleName="flits-box"
            style={{ display: isActive ? 'flex' : 'none' }}
        >
            {displayCard && answer?.name}
        </div>
    );
}
